export const CouldNotInsertHyperLinkTitle = "LOb";
export const BrowseCloudLocationsHyperLink = "MOb";
export const BrowseCloudLocationsOnlyAllowOneFile = "NOb";
export default {CouldNotInsertHyperLinkTitle,BrowseCloudLocationsHyperLink,BrowseCloudLocationsOnlyAllowOneFile};